import {Injectable, OnDestroy} from '@angular/core';
import {CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router} from '@angular/router';
import {AppService} from 'app/services/app.service';
import {HelperService} from 'app/services/helper.service';
import {NavigationService} from 'app/services/navigation.service';
import {UserModelService} from 'app/models/user-model.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivateChild {
  appService: AppService;
  userModelService: UserModelService;
  helperService: HelperService;
  navigationService: NavigationService;
  router: Router;

  // @TODO merge two guards

  constructor(
    appService: AppService,
    helperService: HelperService,
    userModelService: UserModelService,
    navigationService: NavigationService,
    router: Router
  ) {
    this.appService = appService;
    this.userModelService = userModelService;
    this.helperService = helperService;
    this.navigationService = navigationService;
    this.router = router;
  }

  async canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean | UrlTree> {

    if (!this.appService.appReady) {
      await this.helperService.wait(() => this.appService.appReady === true);
    }

    this.navigationService.entryUrl = state.url.replace(/\?(.*)$/gm, '');
    if (!this.userModelService.isLogin()) {
      this.navigationService.goAfterLogin(false);
      return false;
    }

    if (this.userModelService.isLogin()) {
      if (next?.data?.permission) {
        const isOk = this.userModelService.permissions.checkPermission(next.data.permission);

        if (!isOk) {
          this.navigationService.back();
        }

        return isOk;
      } else {
        return true;
      }
    }

    this.navigationService.back();
    return false;
  }

}
